import { useLocale } from "@hooks";
import { convertNextLocaleToLanguage } from "@utils";
import { useEffect, useRef } from "react";
import styled from "styled-components";

export const Trustpilot: React.FC = () => {
  const { locale } = useLocale();
  const widgetRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!widgetRef.current) return;

    const loadWidget = () => {
      if (window.Trustpilot && widgetRef.current) {
        window.Trustpilot.loadFromElement(widgetRef.current, true);
      }
    };

    if (!window.Trustpilot) {
      const script = document.createElement("script");
      script.src = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
      script.async = true;
      script.onload = loadWidget;
      document.body.appendChild(script);
    } else {
      loadWidget();
    }
  }, []);

  return (
    <Container>
      <div
        ref={widgetRef}
        className="trustpilot-widget"
        data-locale={convertNextLocaleToLanguage(locale)}
        data-template-id="5419b6ffb0d04a076446a9af"
        data-businessunit-id="5baa48c16b01ec0001b76165"
        data-style-width="100%"
        data-font-family="Montserrat"
        data-text-color="#5c5757"
      >
        <a href="https://uk.trustpilot.com/review/www.yulife.com" target="_blank" rel="noopener">
          Trustpilot
        </a>
      </div>
    </Container>
  );
};

const Container = styled.div`
  margin-top: 2rem;
  max-width: 420px;

  @media screen and (max-width: 985px) {
    max-width: 170px;
  }
`;
